export function rangeMax(data, paramsDate = "clock") {
  if (
    !Array.isArray(data) ||
    data.length === 0 ||
    !data[0] ||
    !data[data.length - 1] ||
    data[0][paramsDate] === undefined ||
    data[data.length - 1][paramsDate] === undefined
  ) {
    return false;
  }

  const primeiroClock = Number(data[0][paramsDate]);
  const ultimoClock = Number(data[data.length - 1][paramsDate]);

  if (isNaN(primeiroClock) || isNaN(ultimoClock)) return false;

  const diferencaSegundos = ultimoClock - primeiroClock;
  const onzeDiasEmSegundos = 11 * 24 * 60 * 60;

  return diferencaSegundos > onzeDiasEmSegundos;
}
